import React from 'react';

import PasskeyLoginPanel from '../../../components/PasskeyLoginPanel';
import { getCurrentCloudType } from '../../../utilities/env';

type Props = {
  onPasskeyLogin: () => void;
  authenticating?: boolean;
};

const MaybePasskeyLoginPanel = ({ onPasskeyLogin, authenticating }: Props) => {
  const isCommercial = getCurrentCloudType() === 'commercial';

  if (!isCommercial) {
    return null;
  }

  return <PasskeyLoginPanel handlePasskeyLogin={onPasskeyLogin} authenticating={authenticating} />;
};

export default MaybePasskeyLoginPanel;
